export const events = [
  {
    id: "cio-konect",
    slug: "cio-konect",
    name: "CIO Konect Summit",
    tagline: "Where Africa's Technology Leaders Converge",
    badge: "★ Flagship Annual Summit",
    type: "flagship",
    link: "/impact/cio-konect-2025",
    description:
      "Africa's premier gathering for Chief Information Officers, technology executives, and digital transformation leaders. CIO Konect creates a curated environment for peer learning, strategic partnerships, and exposure to the technologies reshaping enterprise IT — including Microsoft AI, cloud strategy, and cybersecurity.",
    extraDescription:
      "Konecta's experts anchor key sessions, positioning the company as the trusted voice at the intersection of technology and African business.",
    meta: [
      { icon: "📍", text: "Johannesburg, SA" },
      { icon: "👥", text: "50+ CIOs & IT Leaders" },
      { icon: "🎙️", text: "10+ Speakers" },
      { icon: "🤝", text: "Sponsorship & Exhibition Available" },
    ],
    gradient: "from-[#0d1a2b] to-[#111]",
    image: "/images/cio-konect-2025/cover.jpg",
  },
  {
    id: "municipal-indaba",
    slug: "municipal-indaba",
    name: "Municipal Indaba",
    tagline: "Smart Cities · eGovernment",
    badge: "🏛️ Government & Municipal",
    type: "secondary",
    link: "/events/municipal-indaba-2026",
    description:
      "Dedicated to South Africa's local government technology agenda. The Municipal Indaba convenes mayors, municipal managers, IT directors, and service delivery officials to address smart city implementation, eGovernment platforms, connectivity for underserved communities, and digital infrastructure planning.",
    stats: [
      { value: "150+", label: "Officials" },
      { value: "40+", label: "Municipalities" },
      { value: "Annual", label: "Frequency" },
    ],
    logoColor: "text-konecta-gold",
    gradient: "from-[#1a1208] to-[#0d0d0d]",
    image: "/images/govtech-2025/cover.jpeg",
  },
  {
    id: "witechnology",
    slug: "witechnology",
    name: "WiTechnology Forum",
    tagline: "Wireless · Telecoms · Innovation",
    badge: "🌍 Pan-African Telecoms",
    type: "secondary",
    link: "/impact/witechnology-summit-2025",
    description:
      "Africa's most influential wireless technology and telecoms innovation platform. WiTechnology brings together MNOs, spectrum regulators, equipment vendors, and independent technologists to shape the future of African connectivity — from 5G rollout to rural broadband and satellite integration.",
    stats: [
      { value: "500+", label: "Delegates" },
      { value: "8+", label: "Countries" },
      { value: "3rd", label: "Edition" },
    ],
    logoColor: "text-konecta-orange",
    gradient: "from-[#1a0808] to-[#0d0d0d]",
    image: "/images/witechnology-summit-2025/cover.jpg",
  },
];

export const witechnologyStats = [
  { value: "500+", label: "Summit Delegates" },
  { value: "25+", label: "Industry Speakers" },
  { value: "3", label: "Annual Editions" },
  { value: "8+", label: "Partner Countries" },
];
